export const dealEduAgentRect = (data) => {
  let groupOptions = [];
  data.QuestionInfo[0]?.ResultList?.map((item, questionId) => {
    let _ItemCoord = item.Coord[0];
    let question = {
      visible: false,
      cantSelect: false,
      fill: 'transparent',
      titleStyle: {
        activeColor: '#4A70FF',
        color: '#F1F6FF'
      },
      activeFill: 'rgba(0, 110, 255, 0.12)',
      stroke: '#AACFFF',
      activeStoke: '#4A70FF',
      label: `题目${questionId + 1}`,
      value: `Question${questionId.toString()}1`,
      key: `Question${questionId.toString()}1`,
      OriginImgHeight: data.QuestionInfo[0].Height,
      OriginImgWidth: data.QuestionInfo[0].Width,
      points: [
        _ItemCoord?.LeftTop?.X || 0, _ItemCoord?.LeftTop?.Y || 0,
        _ItemCoord?.RightTop?.X || 0, _ItemCoord?.RightTop?.Y || 0,
        _ItemCoord?.RightBottom?.X || 0, _ItemCoord?.RightBottom?.Y || 0,
        _ItemCoord?.LeftBottom?.X || 0, _ItemCoord?.LeftBottom?.Y || 0
      ]
    };
    let childrenQuestion = [];
    let QuestionList = item.Question.map(i => i.ResultList).flat(Infinity).filter(item => item != null);
    if (QuestionList?.length > 0) {
      QuestionList.map((item, childId) => {
        let _ItemCoord = item.Coord[0];
        childrenQuestion.push({
          visible: false,
          cantSelect: false,
          titleStyle: {
            activeColor: '#0FB87F',
            color: '#E6F8EF'
          },
          fill: 'transparent',
          activeFill: 'rgba(0, 110, 255, 0.12)',
          stroke: '#AACFFF',
          activeStoke: '#4A70FF',
          label: `子题目${childId + 1}`,
          type: 'children',
          value: `Question${questionId.toString()}${childId.toString()}2`,
          key: `Question${questionId.toString()}${childId.toString()}2`,
          OriginImgHeight: data.QuestionInfo[0].Height,
          OriginImgWidth: data.QuestionInfo[0].Width,
          points: [
            _ItemCoord?.LeftTop?.X || 0, _ItemCoord?.LeftTop?.Y || 0,
            _ItemCoord?.RightTop?.X || 0, _ItemCoord?.RightTop?.Y || 0,
            _ItemCoord?.RightBottom?.X || 0, _ItemCoord?.RightBottom?.Y || 0,
            _ItemCoord?.LeftBottom?.X || 0, _ItemCoord?.LeftBottom?.Y || 0
          ]
        });
      });
    }
    groupOptions.push({
      group: `题目${questionId + 1}`,
      children: [question, ...childrenQuestion]
    });
  });
  return groupOptions.map(i => i.children).flat();
}


export const getPositionRelativeToParent = (element, parent) => {
  const elementRect = element.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  const computedStyle = getComputedStyle(parent);
  const parentBorderLeft = parseFloat(computedStyle.borderLeftWidth) || 0;
  const parentBorderTop = parseFloat(computedStyle.borderTopWidth) || 0;
  const parentPaddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
  const parentPaddingTop = parseFloat(computedStyle.paddingTop) || 0;

  const scrollLeft = parent.scrollLeft;
  const scrollTop = parent.scrollTop;

  const left = elementRect.left - parentRect.left - parentBorderLeft - parentPaddingLeft + scrollLeft;
  const top = elementRect.top - parentRect.top - parentBorderTop - parentPaddingTop + scrollTop;

  return { left, top };
}

//  TODO： 后期改为konva内置的方法
export const cropToBase64 = (image, points,curImgSize) => {
  return new Promise(async (resolve, reject) => {
  if (!image) resolve("");

  const img = new Image();
  let radio = 1 ;
  let _points = points ;
  console.log('cropToBase64',img)
  img.src = image;
  img.crossOrigin = 'Anonymous';
  img.onload = () => {
      if(curImgSize){
        radio = img.width / curImgSize.width
        _points = _points.map(i => (
          {
          x: i.x * radio,
          y: i.y * radio,
        }
        ))
      }
      console.log('cropToBase64 实际尺寸：', img.width, img.height,curImgSize,radio,_points);

    // 定义四边形的四个点（示例坐标）
    // const points = [
    //   { x: 100, y: 100 }, // 左上
    //   { x: 300, y: 150 }, // 右上
    //   { x: 280, y: 350 }, // 右下
    //   { x: 80, y: 300 }   // 左下
    // ];

    // 创建离屏 Canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // 设置 Canvas 尺寸为四边形外接矩形
    const minX = Math.min(..._points.map(p => p.x));
    const maxX = Math.max(..._points.map(p => p.x));
    const minY = Math.min(..._points.map(p => p.y));
    const maxY = Math.max(..._points.map(p => p.y));
    canvas.width = maxX - minX;
    canvas.height = maxY - minY;

    // 创建裁剪路径（四边形）
    ctx.beginPath();
    ctx.moveTo(_points[0].x - minX, _points[0].y - minY);
    _points.forEach(point => {
      ctx.lineTo(point.x - minX, point.y - minY);
    });
    ctx.closePath();
    ctx.clip();
    // 绘制图像（偏移到裁剪区域）
    ctx.drawImage(
      img,
      minX, minY, // 源图像起点
      canvas.width, canvas.height, // 源图像宽高
      0, 0, // 目标起点
      canvas.width, canvas.height // 目标宽高
    );
    // 获取 Base64
    const base64 = canvas.toDataURL('image/png');
    resolve(base64);
  }
  img.onerror = function (err) {
      console.log('任务图片识别失败', err)
      resolve("");
    };
  })
};
